function getItemId(item) {
  return item && item.id !== undefined && item.id !== null ? item.id : ''
}

function hasItemId(id) {
  return id !== undefined && id !== null && id !== ''
}

function findIdIndex(ids, targetId) {
  return ids.findIndex(id => id == targetId)
}

function appendUniqueIds(ids, extraIds) {
  const nextIds = Array.isArray(ids) ? ids.slice() : []
  ;(Array.isArray(extraIds) ? extraIds : []).forEach(id => {
    if (hasItemId(id) && findIdIndex(nextIds, id) < 0) {
      nextIds.push(id)
    }
  })
  return nextIds
}

function removeIds(ids, removeList) {
  const removeSet = new Set(Array.isArray(removeList) ? removeList : [])
  return (Array.isArray(ids) ? ids : []).filter(id => !removeSet.has(id))
}

export function selectListItemWithRange(items, selectedIds, item, anchorId, event) {
  const id = getItemId(item)
  const currentIds = Array.isArray(selectedIds) ? selectedIds.slice() : []
  if (id === '') {
    return {
      selectedIds: currentIds,
      anchorId: anchorId || ''
    }
  }

  if (event && event.shiftKey && anchorId !== undefined && anchorId !== null && anchorId !== '') {
    const orderedIds = (Array.isArray(items) ? items : []).map(getItemId).filter(itemId => itemId !== '')
    const anchorIndex = orderedIds.indexOf(anchorId)
    const targetIndex = orderedIds.indexOf(id)
    if (anchorIndex >= 0 && targetIndex >= 0) {
      const start = Math.min(anchorIndex, targetIndex)
      const end = Math.max(anchorIndex, targetIndex)
      const rangeIds = orderedIds.slice(start, end + 1)
      const selectedSet = new Set(currentIds)
      const allRangeSelected = rangeIds.length > 0 && rangeIds.every(rangeId => selectedSet.has(rangeId))
      const nextIds = allRangeSelected
        ? removeIds(currentIds, rangeIds)
        : appendUniqueIds(currentIds, rangeIds)
      return {
        selectedIds: nextIds,
        anchorId: nextIds.length > 0 ? id : ''
      }
    }
  }

  const selectedIndex = currentIds.indexOf(id)
  if (selectedIndex >= 0) {
    currentIds.splice(selectedIndex, 1)
  } else {
    currentIds.push(id)
  }

  return {
    selectedIds: currentIds,
    anchorId: currentIds.length > 0 ? id : ''
  }
}

export function selectItemWithWindowsRange(items, selectedIds, item, anchorId, event, getId = getItemId) {
  const id = typeof getId == 'function' ? getId(item) : getItemId(item)
  const currentIds = Array.isArray(selectedIds) ? selectedIds.slice() : []
  if (!hasItemId(id)) {
    return {
      selectedIds: currentIds,
      anchorId: anchorId || ''
    }
  }

  const isShift = !!(event && event.shiftKey)
  const isAdditive = !!(event && (event.ctrlKey || event.metaKey))
  const orderedIds = (Array.isArray(items) ? items : [])
    .map(sourceItem => (typeof getId == 'function' ? getId(sourceItem) : getItemId(sourceItem)))
    .filter(hasItemId)

  if (isShift && hasItemId(anchorId)) {
    const anchorIndex = findIdIndex(orderedIds, anchorId)
    const targetIndex = findIdIndex(orderedIds, id)
    if (anchorIndex >= 0 && targetIndex >= 0) {
      const start = Math.min(anchorIndex, targetIndex)
      const end = Math.max(anchorIndex, targetIndex)
      const rangeIds = orderedIds.slice(start, end + 1)
      return {
        selectedIds: isAdditive ? appendUniqueIds(currentIds, rangeIds) : rangeIds,
        anchorId
      }
    }
  }

  if (isAdditive) {
    const selectedIndex = findIdIndex(currentIds, id)
    if (selectedIndex >= 0) {
      currentIds.splice(selectedIndex, 1)
    } else {
      currentIds.push(id)
    }
    return {
      selectedIds: currentIds,
      anchorId: id
    }
  }

  return {
    selectedIds: [id],
    anchorId: id
  }
}
